<app-page-header title="Home" titleLink="/reports" active_item="Movimentações">
</app-page-header>
<form [formGroup]="extrato">
  <div class="row">
    <h5>{{ "common.movement" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTransactionType" class="form-label">{{
                  "common.type" | translate
                }}</label>
                <ng-select
                  id="slTransactionType"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="transactionTypes"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.tipo"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slStatus" class="form-label">{{
                  "common.status" | translate
                }}</label>
                <ng-select
                  id="slStatus"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="statusList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.status"
                >
                </ng-select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <label class="form-label">{{ 'common.notification' | translate }}</label>
              <ng-select
                [clearable]="false"
                [searchable]="false"t
                [items]="webhookStatuses"
                bindLabel="name"
                bindValue="value"
                [formControl]="extrato.controls.statusWebHook"
              >
              </ng-select>
            </div>
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.initialDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    matInput
                    [ngxMatDatetimePicker]="pickerIni"
                    placeholder="DD/MM/YYYY HH:mm"
                    [formControl]="extrato.controls.initialDate"
                  />
                  <ngx-mat-datetime-picker #pickerIni></ngx-mat-datetime-picker>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="$any(pickerIni)"
                  ></mat-datepicker-toggle>
                </mat-form-field>
                <div
                  class="invalid-feedback d-block"
                  *ngIf="extrato.controls.initialDate.invalid && isSubmitted"
                >
                  {{ "common.initialDateRequired" | translate }}
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.finalDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    matInput
                    [ngxMatDatetimePicker]="pickerFim"
                    placeholder="DD/MM/YYYY HH:mm"
                    [formControl]="extrato.controls.endDate"
                  />
                  <ngx-mat-datetime-picker #pickerFim></ngx-mat-datetime-picker>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="$any(pickerFim)"
                  ></mat-datepicker-toggle>
                </mat-form-field>
                <div
                  class="invalid-feedback d-block"
                  *ngIf="extrato.controls.endDate.invalid && isSubmitted"
                >
                  {{ "common.finalDateRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 col-lg-4 col-sm-6">
              <div class="form-group">
                <label for="slOrigin" class="form-label">{{
                  "common.origin" | translate
                }}</label>
                <ng-select
                  [clearable]="false"
                  [items]="originList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.origem"
                  [searchable]="false"
                >
                </ng-select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-4 col-sm-6">
              <div class="form-group">
                <label for="slOrigin" class="form-label">{{
                  "common.application" | translate
                }}</label>
                <ng-select
                  id="slOrigin"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="applicationList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.aplicacao"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTipoBusca" class="form-label">{{
                  "common.searchType" | translate
                }}</label>
                <ng-select
                  id="slTipoBusca"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="tipoBuscaList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.tipoBusca"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDescricao" class="form-label">{{
                  "common.search" | translate
                }}</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    name="descricao"
                    id="txtDescricao"
                    bindValue="value"
                    [formControl]="extrato.controls.responsavel"
                  />
                  <i class="fe fe-copy input-icon" (click)="paste()"></i>
                </div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.amountToReceive" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">{{ aReceber | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.receivedAmount" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{ recebimento | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.averageTicket" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{ ticketMedioRecebimento | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.conversion" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{
                      conversao
                        | mask
                          : "separator.2"
                          : { decimalMarker: ",", leadZero: true }
                    }}%
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.withdrawals" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ saque | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.pendings" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ saquePendente | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up text-primary"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.finalBalance" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ saldoFinal | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.transactions" | translate }}
          </div>
          <div class="card-options">
            <button
              type="button"
              class="btn btn-pill btn-default-light"
              (click)="downloadFile()"
            >
              <i class="fe fe-download me-2"></i>Exportar
            </button>
          </div>
        </div>
        <div class="card-body button-table">
          <app-table-transactions></app-table-transactions>
        </div>
      </div>
    </div>
  </div>
</form>
